// Shared display helpers for SMS delivery status (delivery report and
// Client Messages tab). Statuses come from mNotify, lowercased or not.

const DELIVERY_STATUS = {
    undelivered: { label: 'Not delivered', tone: 'bad', rank: 0 },
    failed: { label: 'Failed', tone: 'bad', rank: 0 },
    rejected: { label: 'Rejected', tone: 'bad', rank: 0 },
    expired: { label: 'Expired', tone: 'bad', rank: 0 },
    sending: { label: 'Sending', tone: 'pending', rank: 1 },
    submitted: { label: 'Sent, awaiting delivery', tone: 'pending', rank: 1 },
    sent: { label: 'Sent, awaiting delivery', tone: 'pending', rank: 1 },
    pending: { label: 'Pending', tone: 'pending', rank: 1 },
    unknown: { label: 'No report', tone: 'unknown', rank: 1 },
    delivered: { label: 'Delivered', tone: 'good', rank: 2 },
};

export const TONE_CLASS = {
    good: 'text-emerald-700 bg-emerald-50 dark:text-emerald-400 dark:bg-emerald-500/10',
    pending: 'text-amber-700 bg-amber-50 dark:text-amber-400 dark:bg-amber-500/10',
    bad: 'text-red-700 bg-red-50 dark:text-red-400 dark:bg-red-500/10',
    unknown: 'text-gray-600 bg-gray-100 dark:text-gray-300 dark:bg-gray-700',
};

export const deliveryStatus = (raw) => DELIVERY_STATUS[String(raw || '').toLowerCase()]
    || { label: raw ? String(raw).charAt(0) + String(raw).slice(1).toLowerCase() : 'Unknown', tone: 'unknown', rank: 1 };

// 233242358387 -> 0242358387, the format staff use everywhere else
export const localPhone = (p) => String(p || '').replace(/^\+?233(?=\d{9}$)/, '0') || '—';
